(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-hulkapps-backup"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer-hulkapps-backup"]) return;
  try {
    
window.addEventListener('load', function() {
  // before submitting the form, check if all the property values are selected
  document.querySelectorAll('.cart__checkout-button').forEach(button => {
    button.addEventListener('click', (event) => {
      const propertyValueInputs = document.querySelectorAll(`[id^="property-value-"]`);

      propertyValueInputs.forEach((input) => {
        if (!input.value || input.value.trim() === "" || input.value.trim() === "選択してください") {
          alert('度数などを選択してください');
          event.preventDefault();
          event.stopPropagation();
          return;
        }
      });
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
window.addEventListener('load', function() {
  // before submitting the form, check if all the property values are selected
  document.querySelectorAll('.cart__checkout-button').forEach(button => {
    button.addEventListener('click', (event) => {
      const propertyValueInputs = document.querySelectorAll(`[id^="property-value-"]`);

      propertyValueInputs.forEach((input) => {
        if (!input.value || input.value.trim() === "" || input.value.trim() === "選択してください") {
          // alert('度数などを選択してください');
          // event.preventDefault();
          // event.stopPropagation();
          // return;
        }
      });
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items-hulkapps-backup"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // on change of select, update the cart
  document.querySelectorAll('.lens-variaion-selector select').forEach(select => {
    select.addEventListener('change', (event) => {

      const idx = event.target.dataset['index'];
      const line = parseInt(event.target.dataset['line']);
      
      const propertyKeyInputs = document.querySelectorAll(`[id^="property-key-${line}-"]`);
      const propertyValueInputs = document.querySelectorAll(`[id^="property-value-${line}-"]`);
     
      const properties = {};
      propertyKeyInputs.forEach((keyInput, index) => {
        const key = keyInput.value.trim();
        const value = propertyValueInputs[index]?.value.trim();

        if (key && value) {
          properties[key] = value;
        }
      });    

      if (Object.keys(properties).length === 0) {
        alert('値が入力されていません。');
        return;
      }

      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          line,
          properties,
        }),
      })
        .then(response => response.json())
        .then(cart => {
          const message = document.getElementById(`update-message-${idx}`);
          message.style.display = 'block';
          message.textContent = `カートの商品が更新されました`;

          setTimeout(() => {
            message.style.display = 'none';
          }, 3000);
        })
        .catch(error => {
          alert('商品の更新に失敗しました。もう一度お試しください。');
        });
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // on change of select, update the cart
  document.querySelectorAll('.lens-variaion-selector select').forEach(select => {
    select.addEventListener('change', (event) => {

      const idx = event.target.dataset['index'];
      const line = parseInt(event.target.dataset['line']);
      
      const propertyKeyInputs = document.querySelectorAll(`[id^="property-key-${line}-"]`);
      const propertyValueInputs = document.querySelectorAll(`[id^="property-value-${line}-"]`);
     
      const properties = {};
      propertyKeyInputs.forEach((keyInput, index) => {
        const key = keyInput.value.trim();
        const value = propertyValueInputs[index]?.value.trim();

        if (key && value) {
          properties[key] = value;
        }
      });    

      if (Object.keys(properties).length === 0) {
        // alert('値が入力されていません。');
        return;
      }

      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          line,
          properties,
        }),
      })
        .then(response => response.json())
        .then(cart => {
          const message = document.getElementById(`update-message-${idx}`);
          message.style.display = 'block';
          message.textContent = `カートの商品が更新されました`;

          setTimeout(() => {
            message.style.display = 'none';
          }, 3000);
        })
        .catch(error => {
          // alert('商品の更新に失敗しました。もう一度お試しください。');
        });
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["side-navigation"] && !window.DesignMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  if (window.innerWidth <= 990) {
    const sideNav = document.querySelector('.side-navigation');
    const header = document.querySelector('header');
    if (sideNav && header) {
      sideNav.style.top = header.offsetHeight + 'px';
    }
  }
});

  } catch(e) { console.error(e); }
})();
})();
